<template>
  <div class="list-item__ticket" @click="executeUsedBook">
    <div class="index-ticket-left">
      <span class="list-item__title passsheet_title">
        Book ID:{{ props.book.id }}を使用済みに変更(Local)
      </span>
    </div>
    <div class="ticket-index-square left-square"></div>
    <div class="ticket-index-square right-square"></div>
  </div>
</template>
<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import API from "@/API";

export default {
  name: "ItemIndexBookUsed",
  props: {
    book: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const executeUsedBook = async () => {
      await API.usedBook(props.book.id);
    };

    return {
      props,
      executeUsedBook,
    };
  },
};
</script>
<style lang="scss" scoped>
.list-item__ticket {
  height: 51px;
  position: relative;
  border-top: 1px dashed #d7d7d7;
}

.list-item__title {
  font-size: 15px;
  position: absolute;
  top: 25%;
  overflow: hidden;
  font-weight: bold;
}

.index-ticket-left {
  float: left;
  width: 100%;
  font-size: 3vw;
  overflow: hidden;
  padding: 0 2%;
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.passsheet_title {
  position: unset;
  display: block;
  margin: 4vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 500;
}

.ticket-index-square {
  position: relative;
  width: 16px;
  height: 16px;
  background-color: #f9f9f9;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  z-index: 0;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
}

.left-square {
  margin-left: -5.5px;
  top: -10px;
  border-bottom: none;
  border-left: none;
}

.right-square {
  margin-left: calc(100% - 12px);
  top: -26px;
  border-top: none;
  border-right: none;
}

@media screen and (min-width: 421px) {
  .list-item__ticket {
    height: 12vw;
  }

  .list-item__title {
    font-size: 4vw;
  }
}
</style>
